const carpayOrderListRoute = '/carpay/orders'

export default carpayOrderListRoute
